/**
 * KISUBIKA wordmark — unlocked on the 100th visit. SVG outline of the tote
 * bag built from the blueprint proportions (430 × 360 × 140 mm, 240 mm handle).
 * Replaces the text logo entirely as a quiet reward for the most loyal visitors.
 */
export const BagOutline = ({ className = "", strokeWidth = 6 }) => (
  <svg
    viewBox="0 0 860 720"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="KISUBIKA — tote outline"
    data-testid="bag-outline"
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Bag body — slight trapezoid (430 × 360) anchored at y = 320 */}
      <path d="M 220 320 L 250 670 L 700 670 L 730 320 Z" />

      {/* Front-face faux depth indication on the left side */}
      <path d="M 220 320 L 200 350 L 234 690 L 250 670" opacity="0.35" />
      <path d="M 234 690 L 680 690 L 700 670" opacity="0.35" />

      {/* Opening line */}
      <path d="M 220 320 Q 475 360 730 320" opacity="0.5" />

      {/* Left handle — half-torus, 240mm drop */}
      <path
        d="M 290 320 C 290 100 470 100 470 320"
        transform="translate(-30 0)"
      />
      {/* Right handle */}
      <path
        d="M 470 320 C 470 100 650 100 650 320"
        transform="translate(40 0)"
      />

      {/* KISUBIKA wordmark across the front, in the centre */}
      <text
        x="475"
        y="510"
        textAnchor="middle"
        stroke="none"
        fill="currentColor"
        fontFamily="Hanken Grotesk, Helvetica Neue, sans-serif"
        fontSize="64"
        fontWeight="700"
        letterSpacing="6"
      >
        KISUBIKA
      </text>
    </g>
  </svg>
);
